import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GalleryData } from 'src/app/features/restaurants/models/Gallery';
import { GalleryService } from 'src/app/features/restaurants/services/Gallary.service';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import Swal from 'sweetalert2';

export interface DialogData {
  restaurantId: number,
  galleryData: GalleryData
}

@Component({
  selector: 'app-gallery-form',
  templateUrl: './gallery-form.component.html'
})

export class GalleryFormComponent extends DirtyComponent implements OnInit {

  dataLoading = false;
  loading = false;
  isSubmitted = false;

  photos: any[] = [];
  videos: any[] = [];

  constructor(
    private service: GalleryService,
    override dialogRef: MatDialogRef<GalleryFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    translate: TranslateService
  ) {
    super(translate)
  }

  ngOnInit(): void {
  }

  override canDeactivate(): boolean {
    return (this.photos.length || this.videos.length) ? true : false;
  };

  saveRecord() {
    this.isSubmitted = true;
    if (this.photos.length || this.videos.length) {
      this.loading = true;
      let data = {
        restaurantId: this.data.restaurantId,
        photos: this.photos,
        videos: this.videos
      };

      this.service.saveRecord(data).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: this.translate.instant('swalMsg.updatedsuccessfully'),
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        this.dialogRef.close(true);
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
    }
  }

}
